'use client';

import { MotionConfig, motion } from 'motion/react';

const hobbies = [
  { emoji: '🛹', label: 'Skateboarding', detail: 'city cruising' },
  { emoji: '🏂', label: 'Snowboarding', detail: 'fresh powder' },
  { emoji: '🏃', label: 'Running', detail: 'first marathon, Oct 2026' },
  { emoji: '🏎️', label: 'Racing', detail: 'anything with wheels' },
  { emoji: '🖨️', label: '3D Printing', detail: 'ideas into objects' },
  { emoji: '⚽', label: 'Soccer', detail: 'beautiful game' },
  { emoji: '🪚', label: 'Woodworking', detail: 'crafting by hand' },
];

const beatbox = {
  emoji: '🎤',
  label: 'Beatbox Vice Champion',
  detail: 'yes, really',
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.1,
    },
  },
};

const chipVariants = {
  hidden: { opacity: 0, y: 16 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring' as const,
      stiffness: 400,
      damping: 25,
    },
  },
};

function HobbyChip({
  emoji,
  label,
  detail,
  isSpecial = false,
}: {
  emoji: string;
  label: string;
  detail: string;
  isSpecial?: boolean;
}) {
  return (
    <motion.div
      variants={chipVariants}
      whileHover={{
        y: -1,
        transition: { type: 'spring', stiffness: 400, damping: 25 },
      }}
      className={`group flex items-center gap-2 rounded-lg border px-3 py-2 transition-shadow duration-200 hover:shadow-sm ${
        isSpecial
          ? 'border-amber-500/30 bg-amber-500/5 hover:border-amber-500/50 hover:shadow-amber-500/5 dark:border-amber-400/20 dark:bg-amber-400/5 dark:hover:border-amber-400/40'
          : 'border-border bg-muted/30 hover:border-muted-foreground/20'
      }`}
    >
      <span className="emoji-wiggle text-lg transition-transform duration-200 group-hover:scale-110">
        {emoji}
      </span>
      <div className="flex flex-col">
        <span
          className={`font-pixelify text-base leading-tight ${
            isSpecial ? 'text-amber-700 dark:text-amber-300' : 'text-foreground'
          }`}
        >
          {label}
        </span>
        <span className="font-mono text-[10px] text-muted-foreground">
          {detail}
        </span>
      </div>
    </motion.div>
  );
}

export function AboutPersonality() {
  return (
    <MotionConfig reducedMotion="user">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-50px' }}
        variants={containerVariants}
        className="mt-6 border-l-2 border-muted-foreground/20 pl-4"
      >
        <motion.p
          variants={chipVariants}
          className="mb-3 font-pixelify text-lg text-muted-foreground"
        >
          ✍️ Off the keyboard...
        </motion.p>

        <div className="flex flex-wrap gap-2">
          {hobbies.map((hobby) => (
            <HobbyChip key={hobby.label} {...hobby} />
          ))}
          <HobbyChip {...beatbox} isSpecial />
        </div>
      </motion.div>
    </MotionConfig>
  );
}
